import React, { ChangeEvent, useState, useRef, useEffect } from 'react';

interface SelectInputProps {
  value?: { value: string | number; label: string } | null | undefined;
  onChange: (option: { value: string | number; label: string } | null) => void;
  size?: 'small' | 'medium' | 'large';
  options?: { value: string | number; label: string }[] | [];
  placeholder?: string;
  dropDownIcon?: React.ReactNode | string;
}

const SelectInput: React.FC<SelectInputProps> = ({
  value,
  onChange,
  size = 'medium',
  options,
  placeholder = 'Select an option',
  dropDownIcon = <span>&#9660;</span>, // Default down arrow
}) => {
  // const [selectedOption, setSelectedOption] = useState<{ value: string | number; label: string } | null>(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const iconContainerRef = useRef<HTMLDivElement>(null);


  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    // Search for the option based on the input value
    const selectedOption = options?.find((option) => option.label === e.target.value) || null;

    // Update the selected option
    // setSelectedOption(selectedOption);

    // Trigger onChange with the selected option
    onChange(selectedOption || null);
  };

  const handleOptionClick = (selectedOption: { value: string | number; label: string } | null) => {
    // Update the selected option
    // setSelectedOption(selectedOption);

    // Trigger onChange with the selected option
    onChange(selectedOption || { value: '', label: '' });

    // Close the dropdown
    setDropdownOpen(false);
  };

  const handleOutsideClick = (e: MouseEvent) => {
    if (inputRef.current && !inputRef.current.contains(e.target as Node) && 
        dropdownRef.current && !dropdownRef.current.contains(e.target as Node) &&
        iconContainerRef.current && !iconContainerRef.current.contains(e.target as Node)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <div className={`custom-select-input ${size}`}>
      <input
        ref={inputRef}
        type="text"
        value={value?.label || ''}
        onChange={handleChange}
        placeholder={placeholder}
        onClick={() => setDropdownOpen(!isDropdownOpen)}
      />
      <div className="icon-container" ref={iconContainerRef}
      onClick={() => setDropdownOpen(!isDropdownOpen)}
      >
        {dropDownIcon && <span className="dropdown-icon">{dropDownIcon}</span>}
      </div>
      {isDropdownOpen && (
        <div ref={dropdownRef} className="custom-dropdown">
          {options?.map((option) => (
            <div
              key={option.value}
              className="dropdown-option"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectInput;


// example usecase:

// const [selectedOption, setSelectedOption] = useState<{ value: string | number; label: string } | null>(null);

//   const options = [
//     { value: 'option1', label: 'Option 1' },
//     { value: 'option2', label: 'Option 2' },
//     { value: 'option3', label: 'Option 3' },
//   ];

//   const handleChange = (option: { value: string | number; label: string } | null) => {
//     setSelectedOption(option);
//   };

//   return (
//     <div className='container'>
//         <SelectInput
//           value={selectedOption?.value || ''}
//           onChange={handleChange}
//           size="medium"
//           options={options}
//           placeholder="Select an option"
//           dropDownIcon={<span>&#9650;</span>} // Custom up arrow icon
//         />
//         </div>
//   )